module.exports = __webpack_public_path__ + "static/media/note.e349a55b.svg";